import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { IndexHeader } from "@/components/IndexHeader";
import { NoteCatalog } from "./NoteCatalog";
import { NotesContent } from "./NotesContent";
import { contentRender } from "@/libs/contentRender";
import { getUserCatalog, queryNote } from "@/api/course";
import { isEmpty } from "@/libs/tools";

@Component({
    components: {
        IndexHeader,
        NoteCatalog,
        NotesContent
    }
})
export default class NotesList extends Vue {
    private courseId: number = 2;
    private version: number | undefined;
    private noteCatalogList: Array<string> = [];
    private queryNoteParams: any = {
        courseId: "",
        sectionId: "",
        chapterId: "",
        moduleId: "",
        sectionGroup: ""
    };
    private currentModule: any = {};
    private currentChapter: any = {};
    private currentSection: any = {};
    private currentGroup: any = {};
    private noteContent: any = "";
    mounted() {
        this.courseId = Number(this.$route.params.courseId);
        this.getCatalogInfo();
    }
    getCatalogInfo() {
        getUserCatalog(this.courseId).then(res => {
            let list = res.data.children;
            this.version = res.data.version;
            this.noteCatalogList = list;
            this.noteCatalogList.forEach((moduleItem: any) => {
                moduleItem.children.forEach((chapterItem: any) => {
                    this.$set(chapterItem, "collapse", false);
                    if (chapterItem.noteStatus) {
                        this.currentChapter = chapterItem;
                        this.currentChapter.children.forEach(groupItem => {
                            if (groupItem.children[0].noteStatus) {
                                this.currentGroup = groupItem;
                                groupItem.children.forEach(sectionItem => {
                                    if (sectionItem.noteStatus) {
                                        this.currentSection = sectionItem;
                                    }
                                });
                            }
                        });
                    }
                });
                if (moduleItem.noteStatus) {
                    this.currentModule = moduleItem;
                    this.getNoteList();
                }
            });
        });
    }
    handleNoteCatalog(
        sectionItem: any,
        chapterItem: any,
        moduleItem: any,
        groupItem: any
    ) {
        this.currentGroup = groupItem;
        this.currentModule = moduleItem;
        this.currentChapter = chapterItem;
        this.currentSection = sectionItem;
        this.getNoteList();
    }
    getNoteList() {
        this.queryNoteParams = {
            courseId: this.courseId,
            moduleId: this.currentModule.id,
            chapterId: this.currentChapter.id,
            sectionGroup: this.currentGroup.groupIndex,
            sectionId: this.currentSection.id
        };
        queryNote(this.queryNoteParams).then(res => {
            this.noteContent = res.data.note;
        });
    }
}
